<template>
  <div class="container">
    <div class="headertitle">
      <span class="letters">项目管理系统</span>
    </div>

    <div class="content">
      <div class="items">
        <input
          type="text"
          v-model="userName"
          class="inputContainer loginName required"
          placeholder="系统登录名"
        />
        <div class="imageIcon">
          <img src="../assets/person.png" alt />
        </div>
      </div>
      <div class="items">
        <input type="password" v-model="psw" class="inputContainer psw required" placeholder="登录密码" />
        <div class="imageIcon">
          <img src="../assets/key.png" alt />
        </div>
      </div>

      <div class="items btn_wrapper">
        <div class="btn login" id="login" @click="login()">登录</div>
      </div>

      <div class="tips">{{tips}}</div>
    </div>
  </div>
</template>

<script>
// import store from '@/vuex/store.js';

export default {
  data() {
    return {
      tips: "",
      userName: "",
      psw: "",
      timer: "",
      web_url: ""
    };
  },
  // store,
  methods: {
    cleartips() {
      this.tips = "";
    },
    login() {
      var _this = this;
      clearTimeout(this.timer);
      if (this.userName == "") {
        this.tips = "请输入用户名";
        this.timer = setInterval(this.cleartips, 1000);
        return;
      }

      if (this.psw == "") {
        this.tips = "请输入密码";
        this.timer = setInterval(this.cleartips, 1000);
        return;
      }

      this.$http
        .post(
          this.web_url + "/login",
          { loginname: this.userName, password: this.psw },
          { emulateJSON: true }
        )
        .then(function(res) {
          if (res.data.status == "ok") {
            // return  false;
            // this.$cookies.remove('user_info');
            // this.$cookies.remove('web_token');
            // this.$store.state.user_info = res.data.data.user_info;
            // this.$store.state.web_token = res.data.data.web_token;

            // this.$cookies.set('user_info', res.data.data.user_info);
            // this.$cookies.set('web_token', res.data.data.web_token);
            // window.web_token = res.data.data.web_token;
            // window.web_url = 'http://pm1.whadshel.com';
            // window.user_info = res.data.data.user_info;
            // window.token =  res.data.data.web_token;

            sessionStorage.removeItem("user_info");
            sessionStorage.removeItem("web_token");
            sessionStorage.setItem(
              "user_info",
              JSON.stringify(res.data.data.user_info)
            );
            sessionStorage.setItem("web_token", res.data.data.web_token);
            // console.log(JSON.parse(JSON.stringify(res.data.data.user_info)))
            //   return  false;
            this.$router.push("/main/project/welcome");
          } else {
            this.tips = res.data.message;
            this.timer = setTimeout(function() {
              _this.tips = "";
            }, 1000);
          }
        })
        .catch(function(res1) {
          this.tips = "网络出错";
          this.timer = setTimeout(function() {
            _this.tips = "";
          }, 1000);
        });
    }
  },
  created() {
    this.web_url = sessionStorage.getItem("web_url");
  }
};
</script>
<style>
.container {
  width: 600px;
  margin: 60px auto 0;
  border: 5px solid #d6d6d6;
  border-radius: 10px;
  /*background: #f3f3f3;*/
}
.headertitle {
  padding: 0 30px 0 20px;
  background: linear-gradient(#fafafa, #d9d9d9);
  /* background:-moz-linear-gradient(top, #f9f8f8, #d1d1d1);
     background:-webkit-gradient(linear,  bottom, from(#f9f8f8), to(#d1d1d1));  */
  line-height: 50px;
}
.letters {
  font-weight: bold;
  font-size: 18px;
  margin-right: 10px;
}
.fr {
  float: right;
}
.close {
  width: 30px;
  height: auto;
  vertical-align: middle;
  cursor: pointer;
}
.txt {
  font-size: 16px;
  color: #666;
}
.items {
  margin: 10px auto;
  text-align: center;
  width: 300px;
  position: relative;
}
.inputContainer {
  line-height: 24px;
  height: 24px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #fff;
  padding: 5px 8px 5px 5px;
  width: 100%;
  vertical-align: top;
}
.verificationCodeItems {
  text-align: left;
  line-height: 34px;
  cursor: pointer;
}
/*.verificationCodeinput{
    margin-right: 50px;
}*/
.verificationCodeinput,
.verificationCode {
  width: 100px;
}
.verificationCode {
  display: inline-block;
  height: 24px;
}
.content {
  overflow: hidden;
}
.lable_tips {
  border-bottom: 1px solid #666;
  vertical-align: bottom;
  font-size: 12px;
  cursor: pointer;
  line-height: 50px;
}
.btn_wrapper {
  text-align: center;
  overflow: hidden;
  margin: 30px auto 0;
}
.tips {
  font-size: 12px;
  color: red;
  text-align: center;
  line-height: 14px;
}
.changePassword {
  margin-left: 20px;
}
.btn {
  border: 1px solid #999;
  background: linear-gradient(#fcfcfc, #d8d8d8);
  margin: 5px auto 10px;
  text-align: center;
  width: 80px;
  line-height: 30px;
  border-radius: 4px;
  cursor: pointer;
}
.imageIcon {
  position: absolute;
  top: 50%;
  margin-top: -16px;
  right: -10px;
  height: 33px;
  background: #fff;
  width: 30px;
  text-align: center;
  line-height: 33px;
}
.imageIcon img {
  width: 20px;
  height: auto;
  vertical-align: middle;
}
.sumbitTips {
  line-height: 16px;
  text-align: center;
  font-size: 12px;
}
.borderRed {
  border: 1px solid red;
}
.changePasswordBtn {
  display: inline-block;
}
#sendPassword,
#login,
#changePassword,
#userRegister,
#modifer {
  background: linear-gradient(#a0c6e4, #337ab7);
  color: #fff;
  line-height: 24px;
}
.gou {
  width: 15px;
  height: auto;
  vertical-align: middle;
}
.none {
  display: none;
}
.rules {
  cursor: pointer;
  font-size: 12px;
  color: #2d6b9f;
  display: inline-block;
}
.modal {
  width: 100%;
  position: fixed;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 11;
}
.loadingWrapper {
  position: absolute;
  height: 120px;
  width: 100px;
  margin-left: -50px;
  left: 50%;
  top: 200px;
}
input::placeholder {
  font-family: "微软雅黑";
}
input::-webkit-input-placeholder {
  font-family: "微软雅黑";
}
input::-moz-placeholder {
  font-family: "微软雅黑";
}
input::-ms-input-placeholder {
  font-family: "微软雅黑";
}
</style>



// WEBPACK FOOTER //
// src/page/login.vue